import axios from 'axios'
import head from 'lodash/head'
import { load_one, load_many, _get_counts } from '../action-helpers.js'
import http from '@/http'
import * as R from "ramda";

export default {

    /**
     * Lädt eine Seite Benutzer vom Server (server-seitige Paginierung).
     * Optionale Filter: status, company.
     * Gibt { users, total } zurück.
     */
    async loadPage({ commit }, { page = 0, size = 20, status, company } = {}) {
        const params = { page, size }
        if (status)  params.status  = status
        if (company) params.company = company
        const response = await http({ method: 'GET', url: 'users', params })
        const users = response.data.content
        commit('SET_MANY', { content: users })
        commit('SET_COUNTS', { content: _get_counts(response.headers) })
        return { users, total: response.data.totalElements }
    },

    create({ dispatch }, { model }) {
        return axios.post('/api/v1/users', model).then(response => {
            return Promise.all([
                dispatch('loadOne', { id: response.data.id }),
                dispatch('loadAll', { force: true }),
                dispatch('persons/loadAll', { force: true }, { root: true })
            ]).then(head)
        })
    },

    loadAll: load_many('users', { setCounts: true }),
    loadAllByCompanyId: load_many('companies/:companyId/users'),
    loadAllByCompanyIdAndIsMediaProduction: load_many('companies/:companyId/users/media-production'),
    loadAllByJobId: load_many('jobs/:jobId/users'),
    loadAllByProductId: load_many('products/:productId/users'),

    loadAllByHasMediaProductionRole: load_many('users', { params: { role: 'MEDIA_PRODUCTION' } }),

    loadOne: load_one('users/:id'),

    loadAllByJobModels({ dispatch }, { jobModels }) {
        return R.compose(

            // Promises zusammenfassen
            promises => Promise.all(promises),

            // Personen zu Job-IDs laden
            R.map(jobId => dispatch('loadAllByJobId', { jobId })),

                // Job-IDs auslesen
            R.map(R.prop('id'))

        )(jobModels)
    },

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/users/${model.id}`, model).then(() => {
            return dispatch('loadOne', { id: model.id, force: true })
        })
    },

}
